export const OrganizationType = {
  PLATFORM_ADMIN: "PLATFORM_ADMIN",
  BRAND: "BRAND",
  MANUFACTURER: "MANUFACTURER",
  SUPPLIER: "SUPPLIER",
  CERTIFIER: "CERTIFIER",
  AUDITOR: "AUDITOR",
} as const

export const OrganizationTypesPermissionLevels = {
  PLATFORM_ADMIN: "PLATFORM_ADMIN",
  BRAND: "BRAND",
  SUPPLIER: "SUPPLIER",
} as const

export const OrganizationTypesPermissionLevelsConfig = {
  [OrganizationTypesPermissionLevels.PLATFORM_ADMIN]: [
    OrganizationType.PLATFORM_ADMIN,
  ],
  [OrganizationTypesPermissionLevels.BRAND]: [OrganizationType.BRAND],
  [OrganizationTypesPermissionLevels.SUPPLIER]: [
    OrganizationType.SUPPLIER,
    OrganizationType.CERTIFIER,
    OrganizationType.AUDITOR,
    OrganizationType.MANUFACTURER,
  ],
} as const

export type OrganizationType =
  (typeof OrganizationType)[keyof typeof OrganizationType]

export type OrganizationPermissionLevel =
  keyof typeof OrganizationTypesPermissionLevels
